import Layout from '@/layout/layout'

const warehousManage = {
  path: '/warehousManage',
  component: Layout,
  redirect: 'noRedirect',
  name: '快递收货',
  children: [
    {
      path: 'receivManage',
      component: () => import('@/views/warehousManage/receivManage/index'),
      name: '快件管理',
      meta: { title: '快件管理', noCache: true }
    },
    {
      path: 'order',
      component: () => import('@/views/warehousManage/order/index'),
      name: '运单监控',
      meta: { title: '运单监控', noCache: true }
  }
  ]
}

export default warehousManage